import React from 'react'

export const GithubIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 0C3.13425 0 0 3.18333 0 7.10961C0 10.4411 2.25867 13.2286 5.30367 14C5.271 13.904 5.25 13.7926 5.25 13.6546V12.4394C4.96592 12.4394 4.48992 12.4394 4.37033 12.4394C3.89142 12.4394 3.46558 12.2303 3.25908 11.8416C3.02983 11.4097 2.99017 10.7491 2.422 10.3451C2.25342 10.2106 2.38175 10.0571 2.576 10.0779C2.93475 10.181 3.23225 10.431 3.51225 10.8019C3.79108 11.1733 3.92233 11.2575 4.44325 11.2575C4.69583 11.2575 5.07383 11.2427 5.42967 11.1858C5.621 10.6923 5.95175 10.2378 6.356 10.0234C4.025 9.77986 2.91258 8.60203 2.91258 7.00296C2.91258 6.31452 3.20133 5.64858 3.69192 5.08752C3.53092 4.5306 3.3285 3.39484 3.75375 2.96234C4.80258 2.96234 5.43667 3.65315 5.58892 3.83978C6.11158 3.65789 6.68558 3.5548 7.28875 3.5548C7.89308 3.5548 8.46942 3.65789 8.99325 3.84097C9.14375 3.65552 9.77842 2.96234 10.8296 2.96234C11.2566 3.39543 11.0518 4.53593 10.8891 5.09166C11.3767 5.65154 11.6638 6.3157 11.6638 7.00296C11.6638 8.60085 10.5531 9.77808 8.22558 10.0228C8.86608 10.3623 9.33333 11.3161 9.33333 12.0348V13.6546C9.33333 13.7162 9.31992 13.7606 9.31292 13.8134C12.0406 12.8423 14 10.2118 14 7.10961C14 3.18333 10.8657 0 7 0Z"
      fill="currentColor"
    />
  </svg>
)
